import { React, useEffect, useState, Fragment,useContext } from "react";
import { Grid as GridKendo, GridColumn as Column } from "@progress/kendo-react-grid";
import { Grid} from '@mui/material';
import * as fairService from "../api/api";
import * as countryService from "../../Country/api/api"
import * as cityService from "../../City/api/api"

import MyCard from '../../../shared/components/myCard'
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";



import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Page from '../../../components/Page';
// Material UI
import { Box, Button, MenuItem, Select, TextField } from '@mui/material';
import * as languageService from "../../Language/api/api"
import * as userService from "../../User/api/api"
import { getValue } from "@testing-library/user-event/dist/utils";
import LocalStorageService from "../../../shared/services/localStorageService";

import { AuthContext } from "src/Auth/components/AuthContext";



function Profile() {
  const {
    authUser
  } = useContext(AuthContext);
//var userId=new LocalStorageService().authData.userId;
var userId = authUser.userId;
useEffect(() => {
    const pagerInputModel = {
        "pageNumber": 1,
        "pageSize": 100
    }

    languageService.list(pagerInputModel).then((res) => {
        const { isSuccess,message, data: languageData } = res;
        if (isSuccess) {
            setLanguageList(languageData);
            getUserData();
        } else {
          toast.error(message);
            console.log(res, "languageData-hata");
        }
        //setIsLoading(false);
    });

 
}, [])



useEffect(() => {



}, [])

    const [photo, setPhoto] = useState();
    const [cancelUpdate, setCancelUpdate] = useState(false);
    const [language, setLanguage] = useState(0);
    const [languageList, setLanguageList] = useState([]);
    
    const defaultInputValues = {
        name: "",
        surname: "",
        email:"",
        language:0,
        photo:""
        
      
        
        
        
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Girilmesi zorunlu alan!'),
        surname: Yup.string().required('Girilmesi zorunlu alan!'),
        email: Yup.string().required('Girilmesi zorunlu alan!'),
        language: Yup.number().required('Seçilmesi zorunlu alan!')
    });


    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
    } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });

function getUserData(){
  const inputModel = {
    "id": userId    
  }
userService.get(inputModel).then((res) => {
    const { isSuccess,message, data: userData } = res;
    if (isSuccess) {
        setValue("name",userData.name);
        setValue("surname",userData.surname);
        setValue("email",userData.email);
        setValue("language",userData.languageId);
        setValue("photo",userData.photo);
        setPhoto("data:image/jpeg;base64,"+userData.photo);
        setLanguage(userData.languageId)
    } else {
      toast.error(message);
        console.log(res, "userdata-hata");
    }    
});
}

function onFileChange(e) {
  let files = e.target.files;
  let fileReader = new FileReader();
  fileReader.readAsDataURL(files[0]);

  fileReader.onload = (event) => {
      setPhoto(event.target.result);
  }
}

function updateUser(){
  const inputModel = {
    "id":userId,
    "name": getValues("name"),
    "surname": getValues("surname"),
    "email": getValues("email"),
    "languageId": getValues("language")
  }
userService.update(inputModel).then((res) => {
    const { isSuccess,message, data: userData } = res;
    if (isSuccess) {
     // getUserData();


      const photoInputModel = {
        "id":userId,
        "photo": photo.split(",")[1]  
      }
      userService.updatePhoto(photoInputModel).then((res) => {
        const { isSuccess,message, data: userData } = res;
        if (isSuccess) {
          getUserData();
      
          toast.success("Verileriniz kaydedildi");
        } else {
          toast.error(message);
            console.log(res, "updatePhoto-hata");
        }    
      });


  
    } else {
      toast.error(message);
        console.log(res, "updateUser-hata");
    }    
});
}

    function languageSelectChangeHandler(event) {
        setLanguage(event.target.value);     
      setValue("language",event.target.value);
    }



  return (
    <Page title="Profilim">
      <Fragment>
        <MyCard header="Kişisel Bilgilerim">
         
          <Grid container xs={4}  spacing={2}>

          <Grid item xs={12}>
          <img src={photo} />
          <input type="file" className="form-control" name="image" onChange={onFileChange} />

          </Grid>
            <Grid item xs={12}>
              <TextField InputLabelProps={{ shrink: true }}
                fullWidth
                required
                id="outlined-required"
                label="Ad"
                error={errors.name ? true : false}
                helperText={errors.name?.message}
                {...register("name")}
                size="small"
              />
            </Grid>

            <Grid item  xs={12} >
              <TextField InputLabelProps={{ shrink: true }}
                fullWidth
                required
                label="Soyad"
                error={errors.surname ? true : false}
                helperText={errors.surname?.message}
                {...register("surname")}
                size="small"
              />
            </Grid>
            <Grid item  xs={12}>
              <TextField InputLabelProps={{ shrink: true }}
                fullWidth
                required
                label="Email"
                error={errors.email ? true : false}
                helperText={errors.email?.message}
                {...register("email")}
                size="small"
              />
            </Grid>        
        

            <Grid item  xs={12}>
              
              <Select InputLabelProps={{ shrink: true }}
               fullWidth
                labelId="selectLanguage"
                id="selectLanguage"
                label="Dil"
               
                size="small"
                {...register("language")}
                value={language}
                onChange={languageSelectChangeHandler}
               
              >
                {languageList.map((itm) => (
                  <MenuItem value={itm.id}>{itm.name}</MenuItem>
                ))}
              </Select>
            </Grid>




            <Grid container spacing={2} padding={2}
  direction="row"
 > <Grid item >
              <Button
                 onClick={handleSubmit(updateUser)}
                variant="contained"
                fullWidth
              >
                Kaydet
              </Button>
              
              </Grid>
              <Grid item >
              <Button
                 onClick={getUserData}
                variant="contained"
                fullWidth
              >
                İptal
              </Button>
              </Grid>


            </Grid>
           
          </Grid>
        </MyCard>
      </Fragment>
     
    </Page>
  );
}

export default Profile;
